"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _phaser = _interopRequireDefault(require("phaser"));
var _cogRed = _interopRequireDefault(require("../../assets/game-assets/cog-red.png"));
var _cogPink = _interopRequireDefault(require("../../assets/game-assets/cog-pink.png"));
var _cogBlue = _interopRequireDefault(require("../../assets/game-assets/cog-blue.png"));
var _cogGreen = _interopRequireDefault(require("../../assets/game-assets/cog-green.png"));
var _cogYellow = _interopRequireDefault(require("../../assets/game-assets/cog-yellow.png"));
var _cogPurple = _interopRequireDefault(require("../../assets/game-assets/cog-purple.png"));
var _arrow = _interopRequireDefault(require("../../assets/game-assets/arrow.png"));
var _background = _interopRequireDefault(require("../../assets/game-assets/background.png"));
var _restart = _interopRequireDefault(require("../../assets/game-assets/restart.png"));
var _shadowbubble = _interopRequireDefault(require("../../assets/game-assets/shadowbubble.png"));
var _lifebubble = _interopRequireDefault(require("../../assets/game-assets/lifebubble.png"));
var _bubble = _interopRequireDefault(require("../../assets/game-assets/bubble.mp3"));
var _shoot = _interopRequireDefault(require("../../assets/game-assets/shoot.mp3"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// @ts-ignore

// @ts-ignore

class PreloadScene extends _phaser.default.Scene {
  constructor() {
    super("PreloadScene");
  }
  preload() {
    this.load.image('red', _cogRed.default);
    this.load.image('pink', _cogPink.default);
    this.load.image('blue', _cogBlue.default);
    this.load.image('green', _cogGreen.default);
    this.load.image('yellow', _cogYellow.default);
    this.load.image('purple', _cogPurple.default);
    this.load.image('arrow', _arrow.default);
    this.load.image('backgroundImage', _background.default);
    this.load.image('restartButtonImage', _restart.default);
    this.load.audio('bubblepop', _bubble.default);
    this.load.audio('bubbleshoot', _shoot.default);
    this.load.image('shadowBubbles', _shadowbubble.default);
    this.load.image('lifeBubbles', _lifebubble.default);
  }
  create() {
    this.scene.start("GameScene");
  }
}
var _default = exports.default = PreloadScene;